module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Dollar-817b6ca2ce6fce8ff0e8c230d1da7f7d.svg";